// Author Liang Gangqiang
// Date 2022-07-04 11:54:35

class SithMesRitaTestTask {
constructor({
        id = null,
        projectId = '',
        wbsNumber = '',
        startTime = '',
        finishedTime = '',
        passedBy = '',
        passed = '',
        cameraOpen = '',
        cameraOpenList = '',
        diagramCodes = '',
        userRelated = '',
        contactName = '',
        contactPhone = '',
        remark = ''}
= {}) {
    this.id = id;
    this.projectId = projectId;
    this.wbsNumber = wbsNumber;
    this.startTime = startTime;
    this.finishedTime = finishedTime;
    this.passedBy = passedBy;
    this.passed = passed;
    this.cameraOpen = cameraOpen;
    this.cameraOpenList = cameraOpenList;
    this.diagramCodes = diagramCodes;
    this.userRelated = userRelated;
    this.contactName = contactName;
    this.contactPhone = contactPhone;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesRitaTestTask();
}

const managerVoConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machine1',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.machine1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'startTime',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.startTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'finishedTime',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.finishedTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'cameraOpen',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.cameraOpen',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'diagramCodes',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.diagramCodes',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'userRelated',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.userRelated',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'contactName',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.contactName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'contactPhone',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.contactPhone',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'passedByName',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.passedByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'passed',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.passed',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentsList',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.attachmentsList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentOpenList',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.attachmentOpenList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentCustomList',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.attachmentCustomList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machine1',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.machine1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'startTime',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.startTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'finishedTime',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.finishedTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'cameraOpen',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.cameraOpen',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'diagramCodes',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.diagramCodes',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'userRelated',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.userRelated',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'contactName',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.contactName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'contactPhone',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.contactPhone',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'passedBy',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.passedBy',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'passedByName',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.passedByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'passed',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.passed',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentsList',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.attachmentsList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentOpenList',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.attachmentOpenList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentCustomList',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.attachmentCustomList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}
const customerVoConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machine1',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.machine1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'startTime',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.startTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'finishedTime',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.finishedTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'contactName',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.contactName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'contactPhone',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.contactPhone',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'passed',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.passed',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentOpenList',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.attachmentOpenList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentCustomList',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.attachmentCustomList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.rita.sithMesRitaTestTask.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ]

const filter = {
    idFilter : '',
    idListFilter : [],
    projectIdFilter : '',
    wbsNumberFilter : '',
    projectCodeFilter : '',
    startTimeRteFilter : '',
    startTimeLteFilter : '',
    finishedTimeRteFilter : '',
    finishedTimeLteFilter : '',
    passedByFilter : '',
    passedFilter : '',
    cameraOpenFilter : '',
    diagramCodesFilter : '',
    userRelatedFilter : '',
    contactNameFilter : '',
    contactPhoneFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTimeRteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.startTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTimeLteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.startTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'finishedTimeRteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.finishedTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'finishedTimeLteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.finishedTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'passedByFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.passedBy',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'passedFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.passed',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cameraOpenFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.cameraOpen',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesRitaCamera'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'diagramCodesFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.diagramCodes',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'userRelatedFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.userRelated',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactNameFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.contactName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactPhoneFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.contactPhone',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];
const managerFilterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTimeRteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.startTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTimeLteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.startTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'finishedTimeRteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.finishedTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'finishedTimeLteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.finishedTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'passedByFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.passedBy',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'passedFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.passed',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cameraOpenFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.cameraOpen',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesRitaCamera'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'diagramCodesFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.diagramCodes',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'userRelatedFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.userRelated',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactNameFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.contactName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactPhoneFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.contactPhone',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];
const customerFilterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTimeRteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.startTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTimeLteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.startTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'finishedTimeRteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.finishedTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'finishedTimeLteFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.finishedTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactNameFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.contactName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactPhoneFilter',
        label: 'label.sith.rita.sithMesRitaTestTask.filter.contactPhone',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const managerEntityConfigs = [
        {
        key: 'wbsNumber',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.wbsNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'sithMesPrdProjectInfo'
            ,correspondingField: 'wbsNumber'
                }
        },
        {
        key: 'startTime',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'finishedTime',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.finishedTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cameraOpenList',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.cameraOpenList',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelectMultiple',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesRitaCamera'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'diagramCodes',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.diagramCodes',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactName',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.contactName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactPhone',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.contactPhone',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]
    const entityFormConfigs = [
        {
        key: 'wbsNumber',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.wbsNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'sithMesPrdProjectInfo'
            ,correspondingField: 'wbsNumber'
                }
        },
        {
        key: 'startTime',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'finishedTime',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.finishedTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cameraOpenList',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.cameraOpenList',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelectMultiple',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesRitaCamera'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'diagramCodes',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.diagramCodes',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactName',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.contactName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contactPhone',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.contactPhone',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.rita.sithMesRitaTestTask.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesRitaTestTask, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs, managerFilterConfigs, customerFilterConfigs
, managerEntityConfigs
, managerVoConfigs, customerVoConfigs
}
